import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import BackToTop from "./BackToTop";
import ChatWidget from "./ChatWidget";
import NotificationBanner from "./NotificationBanner";
import { useAuth } from "../lib/AuthContext";

export default function Layout({ children }) {
  const { unreadCount } = useAuth();
  const hasBanner = unreadCount > 0;
  return (
    <div className="bg-[#0E2452] text-white min-h-screen flex flex-col">
      <Navbar />
      <NotificationBanner />
      <main className={`flex-1 ${hasBanner ? "pt-[70px] md:pt-[62px]" : ""}`}>{children}</main>
      <Footer />
      <WhatsAppFloat />
      <BackToTop />
      <ChatWidget />
    </div>
  );
}
